import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useEffect, useMemo, useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { campaignFetcher } from "../../api/requests";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useToaster } from "../../context/toaster";
import Container from "react-bootstrap/Container";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { getMedalAndRank } from "../CampaignResult";

export default function CreateCampaignResult() {
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params.id;
  const { addMessage } = useToaster();
  const [videos, setVideos] = useState([]);
  const [editableResults, setEditableResults] = useState([]);
  const [sharedResultInfo, setSharedResultInfo] = useState({
    title_result: "",
    selection_criteria: "",
    scoring_formula: "",
    published_date: "",
  });
  const [videoResults, setVideoResults] = useState([]);
  const [selectedMedal, setSelectedMedal] = useState("");
  const [selectedVideo, setSelectedVideo] = useState("");
  const [updateResults, setUpdateResults] = useState(false);

  const mergedEditableResults = useMemo(() => {
    return Object.values(
      editableResults.reduce((acc, obj, index) => {
        const key = obj.title_result;
        if (!acc[key]) {
          acc[key] = {
            title_result: obj.title_result,
            campaign: obj.campaign,
            id: obj.id,
            scoring_formula: obj.scoring_formula,
            selection_criteria: obj.selection_criteria,
            videos_and_medals: [],
          };
        }
        acc[key].videos_and_medals.push({
          video_medal: obj.video_medal,
          video_post_campaign: obj.video_post_campaign,
          editableIndex: index,
        });
        return acc;
      }, {})
    );
  }, [editableResults]);
  
  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type,
      text,
    });
  };

  const handleSharedChange = (name, value) => {
    setSharedResultInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (value) => {
    setSharedResultInfo((prev) => ({
      ...prev,
      published_date: value.toString().replace(/\//g, "-"),
    }));
  };

  const handleAddVideoResult = () => {
    if (!selectedVideo || !selectedMedal) {
      showToast("error", "لطفاً ویدیو و رتبه را انتخاب کنید.");
      return;
    }

    setVideoResults((prev) => [
      ...prev,
      { video_id: selectedVideo, medal: selectedMedal },
    ]);

    setSelectedVideo("");
    setSelectedMedal("");

    showToast("success", "نتیجه به لیست اضافه شد.");
  };

  const handleSubmitAllResults = async () => {
    if (videoResults.length === 0) {
      showToast("error", "هیچ نتیجه‌ای برای ارسال وجود ندارد.");
      return;
    }

    setLoading(true);

    for (const result of videoResults) {
      const formData = new FormData();
      formData.append("campaign", id);
      formData.append("title_result", sharedResultInfo.title_result);
      formData.append(
        "selection_criteria",
        sharedResultInfo.selection_criteria
      );
      formData.append("scoring_formula", sharedResultInfo.scoring_formula);
      formData.append("video_medal", result.medal);
      formData.append("video_post_campaign", result.video_id);
      formData.append("published_date", sharedResultInfo.published_date);

      try {
        const res = await campaignFetcher.postCampaignResult(formData);
        if (res?.id) {
          showToast(
            "success",
            `${getMedalAndRank(result.medal)} با موفقیت ثبت شد.`
          );
          setUpdateResults(!updateResults);
        }
      } catch (error) {
        showToast(
          "error",
          `${getMedalAndRank(result.medal)} ثبت نشد: ${
            error?.response?.data?.detail || "خطای ناشناخته"
          }`
        );
      }
    }

    setLoading(false);
    setVideoResults([]);
  };

  const handleUpdateResult = async (result) => {
    const formData = new FormData();

    const campaignId =
      typeof result.campaign === "object"
        ? result.campaign.id
        : result.campaign;

    const videoId =
      typeof result.video_post_campaign === "object"
        ? result.video_post_campaign.id
        : result.video_post_campaign;

    formData.append("campaign", campaignId);
    formData.append("title_result", result.title_result);
    formData.append("selection_criteria", result.selection_criteria);
    formData.append("scoring_formula", result.scoring_formula);
    formData.append("video_medal", result.video_medal);
    formData.append("video_post_campaign", videoId);
    formData.append("published_date", result.published_date);

    try {
      await campaignFetcher.editCampaignResult(result.id, formData);
      showToast("success", "نتیجه با موفقیت ویرایش شد.");
    } catch (error) {
      showToast(
        "error",
        `خطا در ویرایش نتیجه: ${
          error?.response?.data?.detail?.includes(
            "باید یک مجموعه یکتا باشند"
              ? "این فیلد تکراری می باشد."
              : error?.response?.data?.detail
          ) || "خطای ناشناخته"
        }`
      );
    }
  };

  useEffect(() => {
    const getCampaignVideos = async () => {
      try {
        const res = await campaignFetcher.getCampaignVideos({
          campaignId: id,
          pageSize: 10000,
        });
        setVideos(res?.results);
      } catch (err) {
        console.error(err);
      }
    };

    const getCampaignResults = async () => {
      try {
        const res = await campaignFetcher.getCampaignResult(id);
        setEditableResults(res?.results);
      } catch (err) {
        console.error(err);
      }
    };

    getCampaignVideos();
    getCampaignResults();
  }, [id, updateResults]);

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <Row style={{ padding: "15px" }}>
          <Col lg={12}>
            <div className="osahan-form">
              <Form.Group controlId="title_result">
                <Form.Label>عنوان نتیجه</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="مثلا پربازدیدترین ویدئوها..."
                  onChange={(e) =>
                    handleSharedChange("title_result", e.target.value)
                  }
                />
              </Form.Group>

              <Form.Group controlId="selection_criteria">
                <Form.Label>معیارهای انتخاب</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="مثلا تعداد لایک..."
                  onChange={(e) =>
                    handleSharedChange("selection_criteria", e.target.value)
                  }
                />
              </Form.Group>

              <Form.Group controlId="scoring_formula">
                <Form.Label>فرمول انتخاب برنده</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="مثلا: تعداد لایک + بازدید..."
                  onChange={(e) =>
                    handleSharedChange("scoring_formula", e.target.value)
                  }
                />
              </Form.Group>

              <Row className="mt-4">
                <Col lg={3}>
                  <Form.Group controlId="video_medal">
                    <Form.Label>رتبه</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedMedal}
                      onChange={(e) => setSelectedMedal(e.target.value)}
                    >
                      <option value="">انتخاب کنید</option>
                      {[
                        "Gold",
                        "Silver",
                        "Bronze",
                        "Fourth",
                        "Fifth",
                        "Sixth",
                        "Seventh",
                        "Eighth",
                        "Ninth",
                        "Tenth",
                      ].map((item, idx) => (
                        <option
                          key={idx}
                          value={item}
                          disabled={
                            editableResults
                              .filter(
                                (i) =>
                                  i?.title_result ===
                                  sharedResultInfo.title_result
                              )
                              .find((i) => item === i?.video_medal)
                              ? true
                              : false
                          }
                          title={
                            editableResults
                              .filter(
                                (i) =>
                                  i?.title_result ===
                                  sharedResultInfo.title_result
                              )
                              .find((i) => item === i?.video_medal) &&
                            "این گزینه قبلا انتخاب شده است"
                          }
                        >
                          {getMedalAndRank(item)}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group controlId="video_post_campaign">
                    <Form.Label>ویدیو</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedVideo}
                      onChange={(e) => setSelectedVideo(e.target.value)}
                    >
                      <option value="">انتخاب کنید</option>
                      {videos.map((v) => (
                        <option
                          key={v.id}
                          value={v.id}
                          disabled={
                            editableResults
                              .filter(
                                (i) =>
                                  i?.title_result ===
                                  sharedResultInfo.title_result
                              )
                              .find(
                                (i) =>
                                  v?.title === i?.video_post_campaign?.title
                              )
                              ? true
                              : false
                          }
                          title={
                            editableResults
                              .filter(
                                (i) =>
                                  i?.title_result ===
                                  sharedResultInfo.title_result
                              )
                              .find(
                                (i) =>
                                  v?.title === i?.video_post_campaign?.title
                              ) && "این گزینه قبلا انتخاب شده است"
                          }
                        >
                          {v.title}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col lg={3} className="d-flex align-items-end">
                  <Button variant="success" onClick={handleAddVideoResult}>
                    افزودن به لیست
                  </Button>
                </Col>
              </Row>

              {videoResults.map((res, idx) => {
                const videoTitle = videos.find(
                  (v) => v.id == res.video_id
                )?.title;
                return (
                  <>
                    <div key={idx} style={{ marginTop: "10px" }}>
                      رتبه: {getMedalAndRank(res.medal)} - ویدیو: {videoTitle}
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setVideoResults((prev) =>
                          prev.filter((_, i) => i !== idx)
                        );
                      }}
                      style={{ marginLeft: "10px" }}
                    >
                      حذف
                    </button>
                  </>
                );
              })}

              <Form.Group controlId="published_date" className="mt-3">
                <Form.Label className="ml-1">تاریخ انتشار</Form.Label>
                <DatePicker
                  onChange={handleDateChange}
                  format="YYYY/MM/DD HH:mm:ss"
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom-right"
                />
              </Form.Group>

              <div className="osahan-area text-center mt-4">
                <Button onClick={handleSubmitAllResults} disabled={loading}>
                  {loading ? "در حال ارسال..." : "ارسال نتایج"}
                </Button>
              </div>

              {editableResults?.length > 0 && (
                <>
                  <hr />
                  <h5 className="mt-4">ویرایش نتایج قبلی</h5>
                </>
              )}

              {mergedEditableResults.map((result, index) => {
                const editableIndex =
                  result.videos_and_medals[0]?.editableIndex;
                return (
                  <div
                    key={index}
                    style={{
                      background: "#eef1f5",
                      padding: "15px",
                      borderRadius: "8px",
                      marginTop: "10px",
                    }}
                  >
                    <Form.Group>
                      <Form.Label>عنوان نتیجه</Form.Label>
                      <Form.Control
                        type="text"
                        value={result.title_result}
                        onChange={(e) => {
                          const updated = [...editableResults];
                          updated[editableIndex].title_result = e.target.value;
                          console.error(
                            "Edited item ID:",
                            updated[editableIndex].id
                          );
                          setEditableResults(updated);
                        }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>معیار انتخاب</Form.Label>
                      <Form.Control
                        as="textarea"
                        value={result.selection_criteria}
                        onChange={(e) => {
                          const updated = [...editableResults];
                          updated[editableIndex].selection_criteria =
                            e.target.value;
                          console.error(
                            "Edited item ID:",
                            updated[editableIndex].id
                          );
                          setEditableResults(updated);
                        }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <Form.Label>فرمول امتیازدهی</Form.Label>
                      <Form.Control
                        as="textarea"
                        value={result.scoring_formula}
                        onChange={(e) => {
                          const updated = [...editableResults];
                          updated[editableIndex].scoring_formula =
                            e.target.value;
                          console.error(
                            "Edited item ID:",
                            updated[editableIndex].id
                          );
                          setEditableResults(updated);
                        }}
                      />
                    </Form.Group>
                    {result?.videos_and_medals?.map((item, index) => (
                      <div style={{ display: "flex", gap: "2px" }} key={index}>
                        <Form.Group>
                          <Form.Label>رتبه</Form.Label>
                          <Form.Control
                            as="select"
                            value={item.video_medal}
                            onChange={(e) => {
                              const updated = [...editableResults];
                              updated[item.editableIndex].video_medal =
                                e.target.value;
                              console.error(
                                "Edited item ID:",
                                updated[item.editableIndex].id
                              );
                              setEditableResults(updated);
                            }}
                          >
                            {[
                              "Gold",
                              "Silver",
                              "Bronze",
                              "Fourth",
                              "Fifth",
                              "Sixth",
                              "Seventh",
                              "Eighth",
                              "Ninth",
                              "Tenth",
                            ].map((item, idx) => (
                              <option
                                key={idx}
                                value={item}
                                disabled={result.videos_and_medals.some(
                                  // Does at least one of you meet this condition? returns true or false
                                  (m) => item === m?.video_medal
                                )}
                                title={
                                  result.videos_and_medals.some(
                                    (m) => m.video_medal === item
                                  )
                                    ? "این گزینه قبلا برای این عنوان انتخاب شده است"
                                    : ""
                                }
                              >
                                {getMedalAndRank(item)}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>ویدیو</Form.Label>
                          <Form.Control
                            as="select"
                            value={item.video_post_campaign?.id}
                            onChange={(e) => {
                              const updated = [...editableResults];
                              updated[item.editableIndex].video_post_campaign =
                                parseInt(e.target.value);
                              console.error(
                                "Edited item ID:",
                                updated[item.editableIndex].id
                              );
                              setEditableResults(updated);
                            }}
                          >
                            {videos.map((v) => (
                              <option key={v.id} value={v.id}>
                                {v.title}
                              </option>
                            ))}
                          </Form.Control>
                        </Form.Group>
                        <Button
                          style={{
                            height: "fit-content",
                            alignSelf: "center",
                            marginTop: "9px",
                          }}
                          variant="danger"
                          size="sm"
                          onClick={async () => {
                            if (
                              !window.confirm(
                                "آیا از حذف این مورد مطمئن هستید؟"
                              )
                            )
                              return;

                            try {
                              await campaignFetcher.deleteCampaignResult(
                                result?.id
                              );
                              showToast("success", "نتیجه با موفقیت حذف شد.");
                              const updated = [...editableResults];
                              updated.splice(item.editableIndex, 1);
                              setEditableResults(updated);
                              setUpdateResults(!updateResults);
                            } catch (err) {
                              showToast("error", "خطا در حذف نتیجه");
                              console.error(err);
                            }
                          }}
                        >
                          حذف
                        </Button>
                      </div>
                    ))}

                    <Button
                      className="mt-2"
                      variant="primary"
                      onClick={() => {
                        result.videos_and_medals.forEach((info) => {
                          const realItem = editableResults[info.editableIndex];
                          handleUpdateResult(realItem);
                        });
                      }}
                    >
                      ذخیره تغییرات
                    </Button>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
      <ThinFooter />
    </ContentWrapper>
  );
}
